import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const menuSearchFieldDefaultVariants = {}
const menuSearchFieldCompoundVariants = []

const menuSearchFieldSlotNames = [
  [
    "row",
    "MenuSearchField__row"
  ],
  [
    "icon",
    "MenuSearchField__icon"
  ],
  [
    "input",
    "MenuSearchField__input"
  ]
]
const menuSearchFieldSlotFns = /* @__PURE__ */ menuSearchFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, menuSearchFieldDefaultVariants, getSlotCompoundVariant(menuSearchFieldCompoundVariants, slotName))])

const menuSearchFieldFn = memo((props = {}) => {
  return Object.fromEntries(menuSearchFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const menuSearchFieldVariantKeys = []
const getVariantProps = (variants) => ({ ...menuSearchFieldDefaultVariants, ...compact(variants) })

export const menuSearchField = /* @__PURE__ */ Object.assign(menuSearchFieldFn, {
  __recipe__: false,
  __name__: 'menuSearchField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: menuSearchFieldVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, menuSearchFieldVariantKeys)
  },
  getVariantProps
})